module.exports = __webpack_public_path__ + "static/og-image-d2e3a413c5f63d67a998500b7188cd72.png";